import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var KeycloakTnC = /** @class */ (function (_super) {
    __extends(KeycloakTnC, _super);
    function KeycloakTnC() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contentLoaded = false;
        return _this;
    }
    Object.defineProperty(KeycloakTnC.prototype, "loginAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakTnC.prototype, "version", {
        get: function () {
            return this.kcContext.endeavour_t_and_c_version;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakTnC.prototype.onContentLoad = function () {
        this.contentLoaded = true;
    };
    KeycloakTnC.prototype.submitAccept = function () {
        var form = this.$refs['accept-form'];
        form.submit();
    };
    KeycloakTnC.prototype.submitReject = function () {
        var form = this.$refs['reject-form'];
        form.submit();
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakTnC.prototype, "kcContext", void 0);
    KeycloakTnC = __decorate([
        Component({
            name: 'corex-keycloak-tnc',
        })
    ], KeycloakTnC);
    return KeycloakTnC;
}(Mixins(MagicConfigMixin)));

export default KeycloakTnC;
